import Page from 'components/Page';
import React, {Component} from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,

} from 'reactstrap';

import {validarItem, validarFormulario} from './../utils/validar'; 
import Confirmar from '../components/ModalConfirmar'; 
import Cargando from './../components/Cargando';
import { FaSave , FaTrashAlt} from "react-icons/fa";
import Notificaciones from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';


import Botonera from './../components/BotoneraGuardar';
import u from './../utils/utils';
import TablaTipoUsuario from './../components/TablaTipoUsuario'; 
import TipoUsuario from './../api/TipoUsuario'; 

const tipoUsuario = new TipoUsuario() ; 

class GestorTipoUsuario extends Component {
    constructor() {
        super();
        this.state = {
            id:'',
            nombre:'',
            descripcion: '',
            mod_blog: false,
            mod_cursos: false,
            mod_anuncios:false,
            mod_calificaciones:false,
            mod_material:false,
            mod_postulaciones:false,
            mod_usuarios:false,
            mod_tipousuarios:false,
            mod_estudiantes:false,
            mod_ver_anuncios:false,
            mod_ver_calificaciones:false,
            mod_ver_material:false,
            mod_galeria:false,
            data:[],

            cargando:true,
            validacion:{
                nombre:false,
                descripcion:false
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            idBorrar:''

        }
    }


    estadoDefault = async () => {
        this.setState({
            id:'',
            nombre : '',
            descripcion : '',
            mod_blog : false,
            mod_cursos : false,
            mod_anuncios : false,
            mod_calificaciones : false,
            mod_material : false,
            mod_postulaciones : false,
            mod_usuarios : false,
            mod_tipousuarios : false,
            mod_estudiantes : false,
            mod_ver_anuncios : false,
            mod_ver_calificaciones : false,
            mod_ver_material: false,
            mod_galeria: false,

            validacion:{
                nombre:false,
                descripcion:false
            },
            confirmarGuardar: false,
            confirmarEditar: false, 
            confirmarBorrar: false,
            idBorrar:''
        })
    }


    manejaCambio = (e) => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({ [name]: value });
    }


    cargarListado = async () => {
        let listadoTipos = await tipoUsuario.mostrar(); 
        this.setState({data: listadoTipos, cargando:false}); 
    }


    /* funciones comunes para mensajes y validaciones */ 
    guardarEditarValidando = async ({validacion, confirmar}) =>{
        let validado = await validacion();

        if(validado.resultado){
            confirmar()
        }else{

            for (const k in validado.mensajes) {

                this.Notificaciones.addNotification({
                    message: validado.mensajes[k],
                    level: 'error',
                    position:'tr'
                });
                 
            }
    
        }  

    }

    mensajeGuardadoEditado = async ({resultado, mensaje, icono, tipo}) =>{
        if(resultado==="ok"){

            await this.cargarListado();
            this.estadoDefault();
            
            this.Notificaciones.addNotification({
                title: <FaSave/>,
                message: mensaje,
                level: 'success',
                position:'tr'
            });

        } else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });  
        }

        this.setState({cargando:false});   
    }


    validacionFormulario = async () => {
        let {nombre, descripcion} = this.state;

        let vNombre        = validarItem({valor:nombre, input:'Nombre', vacio:true, largo:45});
        let vDescripcion   = validarItem({valor:descripcion, input:'Descripcion', vacio:false, largo:180});

    
        this.setState({ validacion:{
            nombre:          !vNombre.resultado, 
            descripcion:     !vDescripcion.resultado
        } });  
        
        let formulario = validarFormulario([vNombre, vDescripcion]); 

        return formulario;

    }



    /* ingresar */

    muestraConfirmarGuardar = () => {
        this.setState(prevState => ({
            confirmarGuardar: !prevState.confirmarGuardar
        }));    
    }

    ingresarTipoUsuario = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarGuardar   
        }); 
    }

    ingresarTipoUsuarioBD = async () =>{
        this.setState({cargando:true});

        const {nombre, descripcion, mod_blog, mod_cursos, mod_anuncios, mod_calificaciones, mod_material, mod_postulaciones, mod_usuarios, mod_tipousuarios, mod_estudiantes, mod_ver_anuncios, mod_ver_calificaciones, mod_ver_material, mod_galeria  } = this.state;  
                      
        let resultado = await tipoUsuario.ingresar(nombre, descripcion, mod_blog, mod_cursos, mod_anuncios, mod_calificaciones, mod_material, mod_postulaciones, mod_usuarios, mod_tipousuarios, mod_estudiantes, mod_ver_anuncios, mod_ver_calificaciones, mod_ver_material, mod_galeria)

        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Tipo de usuario ingresado correctamente'})

    }





    /* editar */

    muestraConfirmarEditar = () => {
        this.setState(prevState => ({
            confirmarEditar: !prevState.confirmarEditar
        }));    
    }

    editarTipoUsuario = async () => {
        this.guardarEditarValidando({
            validacion: this.validacionFormulario,
            confirmar: this.muestraConfirmarEditar   
        }); 
    }

    editarTipoUsuarioBD = async () =>{
        this.setState({cargando:true});

        const {id, nombre, descripcion, mod_blog, mod_cursos, mod_anuncios, mod_calificaciones, mod_material, mod_postulaciones, mod_usuarios, mod_tipousuarios, mod_estudiantes, mod_ver_anuncios, mod_ver_calificaciones, mod_ver_material, mod_galeria  } = this.state;  

        let resultado = await tipoUsuario.editar(id, nombre, descripcion, mod_blog, mod_cursos, mod_anuncios, mod_calificaciones, mod_material, mod_postulaciones, mod_usuarios, mod_tipousuarios, mod_estudiantes, mod_ver_anuncios, mod_ver_calificaciones, mod_ver_material, mod_galeria )

        
        this.mensajeGuardadoEditado({resultado:resultado, mensaje: 'Tipo de usuario editado correctamente'})

    }

    cargarEditar = (t) => {
        this.setState({
            id :t.id,
            nombre :t.nombre,
            descripcion: t.descripcion,
            mod_blog: u.toBoolean(t.mod_blog),
            mod_cursos: u.toBoolean(t.mod_cursos),
            mod_anuncios :u.toBoolean(t.mod_anuncios),
            mod_calificaciones :u.toBoolean(t.mod_calificaciones),
            mod_material :u.toBoolean(t.mod_material),
            mod_postulaciones :u.toBoolean(t.mod_postulaciones),
            mod_usuarios :u.toBoolean(t.mod_usuarios),
            mod_tipousuarios :u.toBoolean(t.mod_tipousuarios),
            mod_estudiantes :u.toBoolean(t.mod_estudiantes),
            mod_ver_anuncios :u.toBoolean(t.mod_ver_anuncios),
            mod_ver_calificaciones :u.toBoolean(t.mod_ver_calificaciones),
            mod_ver_material :u.toBoolean(t.mod_ver_material),
            mod_galeria :u.toBoolean(t.mod_galeria),
        }); 
    }






    /* borrar */

    muestraConfirmarBorrar = (id) => {
        this.setState((prevState) => ({
            confirmarBorrar: !prevState.confirmarBorrar,
            idBorrar: id
        }));          
    }

    eliminarTipoUsuario = async () => {
        this.setState({cargando:true});
        
        let resultado = await tipoUsuario.eliminar(this.state.idBorrar)

        if(resultado==="ok"){
            await this.cargarListado();
            
            this.Notificaciones.addNotification({
                title: <FaTrashAlt/>,
                message: 'Tipo de usuario eliminado satisfactoriamente',
                level: 'info',
                position:'tr'
            });
        }else{
            this.Notificaciones.addNotification({
                message: 'Error inesperado, intentelo más tarde',
                level: 'error',
                position:'tr'
            });          
        }

       
        this.setState({cargando:false});
    }





    componentDidMount() {
        this.cargarListado();   
    }


    render() {
        const {id, nombre, descripcion, mod_blog, mod_cursos, mod_anuncios, mod_calificaciones, mod_material, mod_postulaciones, mod_usuarios, mod_tipousuarios, mod_estudiantes, mod_ver_anuncios, mod_ver_calificaciones, mod_ver_material, mod_galeria, data, cargando, confirmarGuardar, confirmarEditar, confirmarBorrar, validacion  } = this.state;  
        return (
            <Page title="Administrador de tipos de usuarios" breadcrumbs={[ { name: 'Tipos de usuarios', active: true } ]}>
        
                <Cargando valor={cargando}/>

                <Card>
                    <CardHeader>Información del tipo de usuario</CardHeader>
                    <CardBody>
                    <Form>
        
                        <Row className="no-margin-bottom">

                            <Col  xl={3} lg={3} md={6} sm={12}>
                                <FormGroup>
                                    <Label>Nombre</Label>
                                    <Input
                                        type="text"
                                        onChange={this.manejaCambio}
                                        name="nombre"
                                        value={nombre}
                                        invalid={validacion.nombre}
                                        maxLength={45}
                                    />
                                </FormGroup>
                            </Col>
                            <Col  xl={9} lg={9} md={6} sm={12}>
                                <FormGroup>
                                    <Label >Descripción</Label>
                                    <Input
                                        type="text"
                                        name="descripcion"
                                        value={descripcion}
                                        onChange={this.manejaCambio}
                                        invalid={validacion.descripcion}
                                        maxLength={180}
                                    />
                                </FormGroup>
                            </Col>
        
                        </Row>
        
                        <Row>
                            <Col sm={12}>
                                <br/>
                                <Label >Permisos de visualización de los modulos</Label>
                            </Col>
                  
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_blog" checked={mod_blog} onChange={this.manejaCambio}/><span className="numcheck">1</span> -  Blog
                                    </Label>
                                </FormGroup>                  
                            </Col>
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_galeria" checked={mod_galeria} onChange={this.manejaCambio}/><span className="numcheck">2</span> -  Galería
                                    </Label>
                                </FormGroup>                  
                            </Col>
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_cursos" checked={mod_cursos} onChange={this.manejaCambio}/><span className="numcheck">3</span> -  Cursos
                                    </Label>
                                </FormGroup>                  
                            </Col>
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_anuncios" checked={mod_anuncios} onChange={this.manejaCambio}/><span className="numcheck">4</span> - Anuncios
                                    </Label>
                                </FormGroup>                  
                            </Col>
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_calificaciones" checked={mod_calificaciones} onChange={this.manejaCambio}/><span className="numcheck">5</span> - Calificaciones
                                    </Label>
                                </FormGroup>                  
                            </Col>
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_material" checked={mod_material} onChange={this.manejaCambio}/><span className="numcheck">6</span> - Material académico
                                    </Label>
                                </FormGroup>                  
                            </Col>
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_postulaciones" checked={mod_postulaciones} onChange={this.manejaCambio}/><span className="numcheck">7</span> - Postulaciones
                                    </Label>
                                </FormGroup>                  
                            </Col>
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_usuarios" checked={mod_usuarios} onChange={this.manejaCambio}/><span className="numcheck">8</span> - Usuarios
                                    </Label>
                                </FormGroup>                  
                            </Col>
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_tipousuarios" checked={mod_tipousuarios} onChange={this.manejaCambio}/><span className="numcheck">9</span> - Tipos de usuarios
                                    </Label>
                                </FormGroup>                  
                            </Col>
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_estudiantes" checked={mod_estudiantes} onChange={this.manejaCambio}/><span className="numcheck">10</span> - Estudiantes
                                    </Label>
                                </FormGroup>                  
                            </Col>
                        
                            <Col  sm={12}>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_ver_anuncios" checked={mod_ver_anuncios} onChange={this.manejaCambio}/><span className="numcheck">11</span> - Ver anuncios (estudiantes)
                                    </Label>
                                </FormGroup>  
                            </Col>
        
                            <Col  sm={12}>                    
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_ver_calificaciones" checked={mod_ver_calificaciones} onChange={this.manejaCambio}/><span className="numcheck">12</span> - Ver calificaciones (estudiantes)
                                    </Label>
                                </FormGroup>  
                            </Col>
        
                            <Col  sm={12}>                 
                                <FormGroup check>
                                    <Label check>
                                        <Input type="checkbox" name="mod_ver_material" checked={mod_ver_material} onChange={this.manejaCambio}/><span className="numcheck">13</span> - Ver material académico (estudiantes)
                                    </Label>
                                </FormGroup>                  
                            </Col>
        
                        </Row>
        
                
                    </Form>
                    </CardBody>

                    <Botonera 
                        valor={id}
                        ingresar={this.ingresarTipoUsuario}
                        editar={this.editarTipoUsuario}
                        cancelar={this.estadoDefault}
                    />



                </Card>
        
        
                <br/>
        
                <TablaTipoUsuario 
                    data = {data}
                    eliminar = {this.muestraConfirmarBorrar}
                    editar = {this.cargarEditar}
                />
        

          
                <Confirmar 
                    isOpen={confirmarGuardar} 
                    toggle={this.muestraConfirmarGuardar} 
                    texto={"¿Esta seguro de guardar el tipo de usuario?"} 
                    funcion={this.ingresarTipoUsuarioBD} 
                />

                 <Confirmar 
                    isOpen={confirmarEditar} 
                    toggle={this.muestraConfirmarEditar} 
                    texto={"¿Esta seguro de editar el tipo de usuario?"} 
                    funcion={this.editarTipoUsuarioBD} 
                />

                 <Confirmar 
                    isOpen={confirmarBorrar} 
                    toggle={this.muestraConfirmarBorrar} 
                    texto={"¿Esta seguro de borrar el tipo de usuario?"} 
                    funcion={this.eliminarTipoUsuario} 
                />


                <Notificaciones
                    dismissible={false}
                    ref={Notificaciones =>
                        (this.Notificaciones = Notificaciones)
                    }
                    style={NOTIFICATION_SYSTEM_STYLE}
                    />
        
            </Page>
        );
    }
    
};

export default GestorTipoUsuario;
